import i18n from '@/libs/i18n'

export default [
  {
    path: '/feedback/list',
    name: 'pages-feedback-list',
    component: () => import('@/views/pages/feedbacks/feedbackList.vue'),
    meta: {
      action: 'read',
      resource: 'feedback',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('feedback.feedback'),
    },
  },
  {
    path: '/feedback/archive',
    name: 'pages-feedback-archive',
    component: () => import('@/views/pages/feedbacks/feedbackArchive.vue'),
    meta: {
      action: 'read',
      resource: 'feedback',
      required: true,
      breadcrumb: [
        {
          text: i18n.t('feedback.feedbackArchive'),
          active: false,
        },
      ],
      pageTitle: i18n.t('feedback.feedbackArchive'),
    },
  },
  {
    path: '/feedback/edit/:id',
    name: 'pages-feedback-edit',
    component: () => import('@/views/pages/feedbacks/feedbackEdit.vue'),
    meta: {
      action: 'update',
      resource: 'feedback',
      required: true,
      breadcrumb: [
        {
          text: i18n.t('comments.status'),
          active: false,
        },
      ],
      pageTitle: i18n.t('comments.status'),
    },

  },

]
